module.exports = __webpack_public_path__ + "static/media/r.fcbf0fc3.svg";